/**
 * List of all the events that are tracked in the app.
 *
 * All new events should be named in snake_case like so: `verb_noun`
 */
var AnalyticsTrackingEvent;
(function (AnalyticsTrackingEvent) {
    AnalyticsTrackingEvent["OPEN_APP"] = "app open";
    AnalyticsTrackingEvent["FINGERPRINTJS_ERROR"] = "fingerprintjs_error";
    AnalyticsTrackingEvent["GRAPHQL_ERROR"] = "graphql_error";
    AnalyticsTrackingEvent["BRANDCLUB_LANDING_PAGE_LOADED"] = "brandclub_landing_page_loaded";
    AnalyticsTrackingEvent["BRANDCLUB_LANDING_PAGE_TEXT_APP_LINK"] = "brandclub_landing_page_text_app_link";
    AnalyticsTrackingEvent["BRANDCLUB_LANDING_PAGE_QRCODE_SCANNED"] = "brandclub_landing_page_qrcode_scanned";
    AnalyticsTrackingEvent["JOINED_BRANDCLUB"] = "joined brandclub";
    AnalyticsTrackingEvent["OPENED_SHARE_AFFILIATE_LINK"] = "Opened share affiliate link";
    AnalyticsTrackingEvent["OPENED_SHARE_REFERRAL_CODE"] = "Opened share referral code";
    AnalyticsTrackingEvent["OPENED_SHARE_PAGE_CARD_LINK"] = "Opened share page card link";
    AnalyticsTrackingEvent["CLOSED_SHARE_AFFILIATE_LINK"] = "Closed share affiliate link";
    AnalyticsTrackingEvent["CLOSED_SHARE_REFERRAL_CODE"] = "Closed share referral code";
    AnalyticsTrackingEvent["CLOSED_SHARE_PAGE_CARD_LINK"] = "Closed share page card link";
    AnalyticsTrackingEvent["SHARED_AFFILIATE_LINK"] = "Shared affiliate link";
    AnalyticsTrackingEvent["SHARED_REFERRAL_CODE"] = "Shared referral code";
    AnalyticsTrackingEvent["SHARED_PAGE_CARD_LINK"] = "Shared page card link";
    AnalyticsTrackingEvent["TEST_EVENT"] = "test event";
    AnalyticsTrackingEvent["MESSAGE_DETAIL_PAGE_OPENED"] = "messageDetailPage opened";
    AnalyticsTrackingEvent["MESSAGE_DETAIL_PAGE_LINK_CLICKED"] = "messageDetailPage link clicked";
    AnalyticsTrackingEvent["SELECTED_SEARCH_TERM_FROM_DROPDOWN"] = "selected search term from dropdown";
    AnalyticsTrackingEvent["SERVER_SIDE_SYNC_MFA_CHOOSE_OPEN"] = "server_side_sync_mfa_choose_open";
    AnalyticsTrackingEvent["SERVER_SIDE_SYNC_MFA_CHOOSE_SUCCESS"] = "server_side_sync_mfa_choose_success";
    AnalyticsTrackingEvent["SERVER_SIDE_SYNC_MFA_CHOOSE_ERROR"] = "server_side_sync_mfa_choose_error";
    AnalyticsTrackingEvent["SERVER_SIDE_SYNC_MFA_ENTER_OPEN"] = "server_side_sync_mfa_enter_open";
    AnalyticsTrackingEvent["SERVER_SIDE_SYNC_MFA_ENTER_SUCCESS"] = "server_side_sync_mfa_enter_success";
    AnalyticsTrackingEvent["SERVER_SIDE_SYNC_MFA_ENTER_ERROR"] = "server_side_sync_mfa_enter_error";
    AnalyticsTrackingEvent["SAVE_REVIEW"] = "save review";
    AnalyticsTrackingEvent["INVALID_REVIEW"] = "invalid review";
    AnalyticsTrackingEvent["SAVE_REVIEW_SUCCESS"] = "save review success";
    AnalyticsTrackingEvent["ERROR_WHILE_SAVING_REVIEW"] = "error while saving review";
    AnalyticsTrackingEvent["BACK_REVIEW"] = "back_review";
    AnalyticsTrackingEvent["STARTED_SUBMIT_REVIEW"] = "started submit review";
    AnalyticsTrackingEvent["SENDING_NON_ELIGIBLE_REVIEW_TO_BRAND"] = "Sending non-eligible review to brand";
    AnalyticsTrackingEvent["SELECTED_APP_REVIEW_OPTION"] = "selected app review option";
    AnalyticsTrackingEvent["SKIPPED_LEAVE_APP_REVIEW"] = "skipped leave app review";
    AnalyticsTrackingEvent["CONTINUE_REVIEW"] = "continue_review";
    AnalyticsTrackingEvent["STARTED_SCANNING"] = "Started scanning";
    AnalyticsTrackingEvent["ERROR_WHILE_SCANNING"] = "Error while scanning";
    AnalyticsTrackingEvent["COMPLETED_SCANNING"] = "Completed scanning";
    AnalyticsTrackingEvent["RETAILER_SYNC_STARTED"] = "retailer_sync_started";
    AnalyticsTrackingEvent["RETAILER_SYNC_COMPLETED"] = "retailer_sync_completed";
    AnalyticsTrackingEvent["DISCONNECT_RETAILER"] = "disconnect_retailer";
    AnalyticsTrackingEvent["MOBILE_APP_SOCIAL_LINK_OPEN_PRODUCT_PAGE"] = "mobileApp:socialLink:openProductPage";
    AnalyticsTrackingEvent["MOBILE_APP_SOCIAL_LINK_PRODUCT_NOT_FOUND"] = "mobileApp:socialLink:productNotFound";
    AnalyticsTrackingEvent["MOBILE_APP_SOCIAL_LINK_CLOSE_RETAILER_PRODUCT_PAGE"] = "mobileApp:socialLink:closeRetailerProductPage";
    AnalyticsTrackingEvent["MOBILE_APP_ORGANIC_OPEN_PRODUCT_PAGE"] = "mobileApp:organic:openProductPage";
    AnalyticsTrackingEvent["MOBILE_APP_ORGANIC_PRODUCT_NOT_FOUND"] = "mobileApp:organic:productNotFound";
    AnalyticsTrackingEvent["MOBILE_APP_ORGANIC_CLOSE_RETAILER_PRODUCT_PAGE"] = "mobileApp:organic:closeRetailerProductPage";
    AnalyticsTrackingEvent["MOBILE_APP_PRODUCT_PAGE_SCROLL"] = "mobileApp:productPage:scroll";
    AnalyticsTrackingEvent["WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK"] = "webApp:socialLink:textAppDownloadLink";
    AnalyticsTrackingEvent["WEB_APP_ORGANIC_ADD_TO_CART"] = "webApp:organic:addToCart";
    AnalyticsTrackingEvent["OPEN_RETAILER_PRODUCT_PAGE"] = "openRetailerProductPage";
    AnalyticsTrackingEvent["WEB_APP_ORGANIC_OPEN_VIEW_OFFERS"] = "webApp:organic:openViewOffers";
    AnalyticsTrackingEvent["WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE"] = "webApp:organic:openRetailerProductPage";
    AnalyticsTrackingEvent["WEB_APP_PRODUCT_PAGE_SCROLL"] = "webApp:productPage:scroll";
    AnalyticsTrackingEvent["ACCOUNTS_HOME_RETAILERS"] = "accounts_home_retailers";
    AnalyticsTrackingEvent["AUTO_SIGN_IN"] = "auto sign in";
    AnalyticsTrackingEvent["ERROR_ON_NEXT_IN_SIGN_UP"] = "error on next in sign up";
    AnalyticsTrackingEvent["OPENED_TERMS_OF_SERVICE"] = "opened terms of service";
    AnalyticsTrackingEvent["OPENED_PRIVACY_POLICY"] = "opened privacy policy";
    AnalyticsTrackingEvent["SIGN_UP"] = "sign up";
    AnalyticsTrackingEvent["SIGN_IN"] = "sign in";
    AnalyticsTrackingEvent["SIGN_OUT"] = "sign out";
    AnalyticsTrackingEvent["SIGN_IN_FAILURE"] = "sign in failure";
    AnalyticsTrackingEvent["COMPLETED_ONBOARDING"] = "completed_onboarding";
    AnalyticsTrackingEvent["VERIFIED_PHONE_NUMBER"] = "verified phone number";
    AnalyticsTrackingEvent["RESEND_PHONE_VERIFICATION"] = "resend phone verification";
    AnalyticsTrackingEvent["ERROR_VERIFYING_PHONE_VERIFICATION_CODE"] = "error verifying phone verification code";
    AnalyticsTrackingEvent["PASSWORD_RESET_ATTEMPTS"] = "password reset attempts";
    AnalyticsTrackingEvent["PASSWORD_RESET_SUCCESSFUL"] = "password reset successful";
    AnalyticsTrackingEvent["SELECTED_SIGN_UP_WITH_EMAIL"] = "selected sign up with email";
    AnalyticsTrackingEvent["SELECTED_FEDERATED_SIGN_IN"] = "selected federated sign in";
    AnalyticsTrackingEvent["LOGIN_SCREEN_VISITS"] = "login screen visits";
    AnalyticsTrackingEvent["BC_CHECKOUT_OPEN_BAG_PAGE"] = "bc_checkout_open_bag_page";
    AnalyticsTrackingEvent["WEBVIEW_WHITE_SCREEN"] = "webview white screen";
    AnalyticsTrackingEvent["BRANDCLUB_SEARCH_TERM"] = "brandclubSearchTerm";
    AnalyticsTrackingEvent["STARTED_TUTORIAL"] = "started tutorial";
    AnalyticsTrackingEvent["COMPLETED_TUTORIAL"] = "completed tutorial";
    AnalyticsTrackingEvent["DAILY_DEALS_PRODUCT_CARD_CLICK"] = "Daily deals product card click";
    AnalyticsTrackingEvent["START_SURVEY"] = "start_survey";
    AnalyticsTrackingEvent["SURVEY_FAILED"] = "survey failed";
    AnalyticsTrackingEvent["SURVEY_RESTART"] = "survey restart";
    AnalyticsTrackingEvent["SURVEY_CANCEL"] = "survey cancel";
    AnalyticsTrackingEvent["COMPLETED_SURVEY"] = "completed survey";
    AnalyticsTrackingEvent["BACK_SURVEY"] = "back_survey";
    AnalyticsTrackingEvent["SELECTED_SURVEY_OPTION"] = "selected_survey_option";
    AnalyticsTrackingEvent["START_CONTENT"] = "start_content";
    AnalyticsTrackingEvent["RESTART_CONTENT"] = "restart_content";
    AnalyticsTrackingEvent["CANCEL_CONTENT"] = "cancel_content";
    AnalyticsTrackingEvent["BACK_CONTENT"] = "back_content";
    AnalyticsTrackingEvent["CONTINUE_CONTENT"] = "continue_content";
    AnalyticsTrackingEvent["FAILED_CONTENT"] = "failed_content";
    AnalyticsTrackingEvent["COMPLETED_CONTENT"] = "completed_content";
    AnalyticsTrackingEvent["CASH_OUT_REQUESTED"] = "cash out requested";
    AnalyticsTrackingEvent["CASH_OUT_SUCCESS"] = "cash out success";
    AnalyticsTrackingEvent["CASH_OUT_FAILED"] = "cash out failed";
    AnalyticsTrackingEvent["EMPTY_CASH_OUT"] = "empty_cash_out";
    AnalyticsTrackingEvent["SYNC_SUMMARY_NOTIFICATION"] = "Sync Summary Notification";
    AnalyticsTrackingEvent["SEARCH"] = "search";
    AnalyticsTrackingEvent["NO_SEARCH_RESULTS"] = "no search results";
    AnalyticsTrackingEvent["SEARCH_ERROR"] = "Search error";
    AnalyticsTrackingEvent["DEEPLINK_OPEN_SUCCESS"] = "deeplink open success";
    AnalyticsTrackingEvent["DEEPLINK_OPEN_ERROR"] = "deeplink open error";
    AnalyticsTrackingEvent["NOTIFICATION_OPEN_SUCCESS"] = "notification open success";
    AnalyticsTrackingEvent["NOTIFICATION_OPEN_ERROR"] = "notification open error";
    AnalyticsTrackingEvent["NOTIFICATION_USER_RESPONDED"] = "notification user responded";
    AnalyticsTrackingEvent["OPENED_APP_LINK"] = "opened app link";
    AnalyticsTrackingEvent["ERROR_OPENING_APP_LINK"] = "error opening app link";
    AnalyticsTrackingEvent["ERROR_OPENING_BRANCH_APP_LINK"] = "error opening branch app link";
    AnalyticsTrackingEvent["ERROR_PAGE"] = "error page";
    AnalyticsTrackingEvent["WARNING"] = "warning";
    AnalyticsTrackingEvent["ERROR"] = "error";
    AnalyticsTrackingEvent["RETURN_PANIC"] = "return panic";
    AnalyticsTrackingEvent["TOMBSTONE"] = "tombstone: ";
    AnalyticsTrackingEvent["INITIATE_CHECKOUT"] = "initiate_checkout";
    AnalyticsTrackingEvent["VIEW_BAG"] = "view_bag";
    AnalyticsTrackingEvent["EMPTY_BAG"] = "empty_bag";
    AnalyticsTrackingEvent["BAG_FULL"] = "bag_full";
    AnalyticsTrackingEvent["UPDATE_BAG_QUANTITY"] = "update_bag_quantity";
    AnalyticsTrackingEvent["CLOSE_CHECKOUT_ERROR"] = "close_checkout_error";
    AnalyticsTrackingEvent["CHECKOUT_ERROR"] = "checkout_error";
    AnalyticsTrackingEvent["CHECKOUT_NEXT_RETAILER"] = "checkout_next_retailer";
    AnalyticsTrackingEvent["SKIP_CHECKOUT"] = "skip_checkout";
    AnalyticsTrackingEvent["VIEW_CHECKOUT_SUMMARY"] = "view_checkout_summary";
    AnalyticsTrackingEvent["REMOVE_CHECKOUT_OUT_OF_STOCK"] = "remove_checkout_out_of_stock";
    AnalyticsTrackingEvent["CONFIRM_CHECKOUT_PARTIAL_OUT_OF_STOCK"] = "confirm_checkout_partial_out_of_stock";
    AnalyticsTrackingEvent["ALL_OUT_OF_STOCK"] = "all_out_of_stock";
    AnalyticsTrackingEvent["ADD_PAYMENT_METHOD"] = "add_payment_method";
    AnalyticsTrackingEvent["DELETE_PAYMENT_METHOD"] = "delete_payment_method";
    AnalyticsTrackingEvent["UPDATE_PAYMENT_METHOD"] = "update_payment_method";
    AnalyticsTrackingEvent["CANCEL_UPDATE_PAYMENT_METHOD"] = "cancel_update_payment_method";
    AnalyticsTrackingEvent["SAVE_UPDATE_PAYMENT_METHOD"] = "save_update_payment_method";
    AnalyticsTrackingEvent["ADD_ADDRESS"] = "add_address";
    AnalyticsTrackingEvent["DELETE_ADDRESS"] = "delete_address";
    AnalyticsTrackingEvent["UPDATE_ADDRESS"] = "update_address";
    AnalyticsTrackingEvent["CANCEL_UPDATE_ADDRESS"] = "cancel_update_address";
    AnalyticsTrackingEvent["SAVE_UPDATE_ADDRESS"] = "save_update_address";
    AnalyticsTrackingEvent["UPDATE_SECURITY"] = "update_security";
    AnalyticsTrackingEvent["CANCEL_UPDATE_SECURITY"] = "cancel_update_security";
    AnalyticsTrackingEvent["SAVE_UPDATE_SECURITY"] = "save_update_security";
    AnalyticsTrackingEvent["CHECKOUT_SUCCESS"] = "checkout_success";
    AnalyticsTrackingEvent["CANCEL_UPDATE_PROFILE"] = "cancel_update_profile";
    AnalyticsTrackingEvent["SAVE_UPDATE_PROFILE"] = "save_update_profile";
    AnalyticsTrackingEvent["BUY_AGAIN"] = "buy_again";
    AnalyticsTrackingEvent["TRACK_PACKAGE"] = "track_package";
    AnalyticsTrackingEvent["VIEW_PURCHASE"] = "view_purchase";
    AnalyticsTrackingEvent["VIEW_PRODUCT"] = "view_product";
    AnalyticsTrackingEvent["EMPTY_PURCHASES"] = "empty_purchases";
    AnalyticsTrackingEvent["EMPTY_REWARDS"] = "empty_rewards";
    AnalyticsTrackingEvent["GET_APP"] = "get_app";
    AnalyticsTrackingEvent["REWARD_INFO"] = "reward_info";
    AnalyticsTrackingEvent["CLOSE_HOME_MENU"] = "close_home_menu";
    AnalyticsTrackingEvent["LANDING_PAGE_VIDEO_PLAY_STARTED"] = "landingPage:videoPlayStarted";
    AnalyticsTrackingEvent["LANDING_PAGE_VIDEO_PLAY_PAUSED"] = "landingPage:videoPlayPaused";
    AnalyticsTrackingEvent["LANDING_PAGE_VIDEO_PLAY_ENDED"] = "landingPage:videoPlayEnded";
    AnalyticsTrackingEvent["PAGE_VIEW"] = "page view";
    AnalyticsTrackingEvent["BC_USER_REQUESTED_CHECKOUT"] = "bc_user_requested_checkout";
    AnalyticsTrackingEvent["BC_USER_ADDED_TO_BAG_FROM_URL"] = "bc_user_added_to_bag_from_url";
    // Checkout V2 Events
    AnalyticsTrackingEvent["CHECKOUT_INTENT_CREATED"] = "bc_checkout_intent_created";
    AnalyticsTrackingEvent["CHECKOUT_PAGE_VIEW"] = "bc_checkout_page_view";
    AnalyticsTrackingEvent["CHECKOUT_STEP_VIEWED"] = "bc_checkout_step_viewed";
    AnalyticsTrackingEvent["CHECKOUT_STEP_COMPLETED"] = "bc_checkout_step_completed";
    AnalyticsTrackingEvent["CHECKOUT_STEP_ERROR"] = "bc_checkout_step_error";
    AnalyticsTrackingEvent["CHECKOUT_RETAILER_FORGOT_PASSWORD_CLICK"] = "bc_checkout_retailer_forgot_password_click";
    AnalyticsTrackingEvent["CHECKOUT_PAYMENT_ADD"] = "bc_checkout_payment_add";
    AnalyticsTrackingEvent["CHECKOUT_PAYMENT_SELECT"] = "bc_checkout_payment_select";
    AnalyticsTrackingEvent["CHECKOUT_ORDER_SUBMIT"] = "bc_checkout_order_submit";
    AnalyticsTrackingEvent["CHECKOUT_ORDER_SUCCESS"] = "bc_checkout_order_success";
    AnalyticsTrackingEvent["CHECKOUT_ORDER_FAILURE"] = "bc_checkout_order_failure";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_SCREEN_VISIT"] = "bc_checkout_connect_screen_visit";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_OTP_POPUP_OPEN"] = "bc_checkout_connect_otp_popup_open";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_OTP_SUBMIT"] = "bc_checkout_connect_otp_submit";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_OTP_RESEND"] = "bc_checkout_connect_otp_resend";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_OTP_TIMEOUT_RETRY"] = "bc_checkout_connect_otp_timeout_retry";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_CREDENTIALS_POPUP_OPEN"] = "bc_checkout_connect_credentials_popup_open";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_CREDENTIALS_SUBMIT"] = "bc_checkout_connect_credentials_submit";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_CREDENTIALS_TIMEOUT_RETRY"] = "bc_checkout_connect_credentials_timeout_retry";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_SUCCESS_SCREEN_VISIT"] = "bc_checkout_connect_success";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_SUCCESS_TRACK_ORDER_CLICK"] = "bc_checkout_connect_success_track_order_click";
    AnalyticsTrackingEvent["CHECKOUT_CONNECT_SUCCESS_CONTINUE_SHOPPING_CLICK"] = "bc_checkout_connect_success_continue_shopping_click";
    AnalyticsTrackingEvent["CHECKOUT_SUMMARY_SCREEN_VISIT"] = "bc_checkout_summary_visit";
})(AnalyticsTrackingEvent || (AnalyticsTrackingEvent = {}));

export { AnalyticsTrackingEvent };
//# sourceMappingURL=events.js.map
